import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  tableNameMatcher,
  useTableChangeVersion,
} from "@-/dev.improve.haniverse.lib.database.change";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { readHanWallet } from "#read-han-wallet";

/** Every table the wallet is derived from. */
export const HAN_WALLET_TABLE_NAMES = [
  "user_card_review",
  "reward_claim",
  "travel_trip",
  "user_quest",
];

function useGetHanWalletQueryKey() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  const withTableChangeVersion = useTableChangeVersion(tableNameMatcher(HAN_WALLET_TABLE_NAMES));
  return () => withTableChangeVersion(["hanWallet", { actorDb }] as const);
}

/** The learner's Han, dragons and HanMiles ({@link readHanWallet}). */
export const [useHanWalletQueryOptions] = createUseQueryOptions(
  useGetHanWalletQueryKey,
  async ({ queryKey: [_, { actorDb }] }) => readHanWallet(actorDb(import.meta.location)),
);
